module.exports = __webpack_public_path__ + "static/img/NSW-5.bcd8e37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-5.jpg
// module id = VICQ
// module chunks = 0